var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages agree_container"},[(_vm.app === 'hsjpro')?_c('hsjpro-priacy'):_vm._e(),_c('hsj-priacy')],1)}
var staticRenderFns = []

export { render, staticRenderFns }